import React, {useState} from "react";
import { Container,  FormContainer, Row,  Col,LoginNotice } from './styles'

export const LoginForm = (props) => {
    const [messageLogin, setmessageLogin] = useState('Introduce tu código para iniciar sesión');

    const [userPass, setUserPass] = useState(null);

    const messageLoginChange = (val) => {
        setmessageLogin(val)
    }
   
    const passChange = (val) => {
        setUserPass(val.target.value)
    }
    const fetchData = async () => {
        /*const result = await axios(
            `/login`,
        );*/
        //setLoginData(result.data);

        let hasErros = null
        
        
        if(userPass === null){
            hasErros = true
            document.getElementById('passLogin').classList.add('hasError');
        }else{
            document.getElementById('passLogin').classList.remove('hasError');
        } 

        if(hasErros === null){ 
            //let md5pass = md5(userPass) 
            let md5pass = userPass
            if(md5pass.length  == 15){
                var addon="";
                for(var block=0;block<3; block++)
                {
                    var loop=0;
                    for(var position=0;position<5;position++){
                        var current=md5pass.charAt(block*5+position);
                        if(current>="A" && current<="Z")
                            loop+=1<<position;
                    }
                    addon+="ABCDEFGHIJKLMNOPQRSTUVWXYZ012345".charAt(loop);
                }
                md5pass=(md5pass+addon);
            }
            

            try {
                var dataForm = {
                    claveUsuario: md5pass,
                };
                const url = `https://eventosonline.spinmedia.es/api/auth/loginSF/`
                const requestOptions = {
                  method: 'POST',
                  body: JSON.stringify(dataForm),
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                  },  
                }
                let respuesta = await fetch(url, requestOptions)
                let resultado = await respuesta.json()
                //console.log(resultado.data)
                sessionStorage.setItem(`${process.env.REACT_APP_EVENTO_ID}index-Nombre_USERRADIO`, resultado.data.idUsuario) 
                sessionStorage.setItem(`${process.env.REACT_APP_EVENTO_ID}index-Nombre_NAMEUSERRADIO`, resultado.data.nombre) 
                sessionStorage.setItem(`${process.env.REACT_APP_EVENTO_ID}index-Nombre_TOKENUSERRADIO`, resultado.data.token) 
                sessionStorage.setItem(`${process.env.REACT_APP_EVENTO_ID}index-Name_Id`, md5pass)
                sessionStorage.setItem(`${process.env.REACT_APP_EVENTO_ID}index-EMAIL`, resultado.data.email)

                
                props.activateAuth()
              } catch (error) {
                console.log('Error: ', error)
              }



        }else{
            messageLoginChange('Rellena todos los campos para iniciar sesión')
        }
    };

    

    return(
        <Container>
            <FormContainer>
            <Col>
                <LoginNotice>{messageLogin}</LoginNotice>
            </Col>
                <Row>
                    
                    <form onSubmit={(e) => {fetchData(); e.preventDefault();}}>
                        <input className="input-form" type="text" id="passLogin" name="passLogin" placeholder="Código" onChange={passChange} />
                        <Col>
                            <button className="btn primary" type="button" onClick={fetchData}>Iniciar sesión</button>
                            
                        </Col>
                    </form>
                    
                </Row>
            </FormContainer>
            
        </Container>
    );
    
} 
